/**
 * Tier coercion utility for SDUI config system.
 *
 * Converts entitlement tier strings (which may include "family_member"
 * or be undefined) into UISpecTier values safe for useSDUIConfig().
 *
 * Eliminates `(tier as any) || 'free'` casts scattered across consumers.
 */

import type { UISpecTier } from "./use-ui-spec";

const VALID_TIERS: UISpecTier[] = ["anonymous", "free", "drama_plus", "dramax"];

/**
 * Coerce any tier string into a UISpecTier.
 * - undefined/null → 'free'
 * - 'family_member' → 'drama_plus' (family members inherit admin tier)
 * - invalid string → 'free'
 */
export function toUISpecTier(tier: string | undefined | null): UISpecTier {
  if (!tier) return "free";
  if (tier === "family_member") return "drama_plus";
  return VALID_TIERS.includes(tier as UISpecTier)
    ? (tier as UISpecTier)
    : "free";
}
